import { tiers } from '../config/tiers';
import { mapBetweenRanges } from './numberUtils';

export function getPrice(traffic) {
  if (traffic < 25000) return 450;

  if (traffic > 15000000) {
    const extra = traffic - 15000000;
    return 19500 + extra * 0.001;
  }

  const lowerTier = tiers.findLast((tier) => traffic > tier.maxTraffic);
  const upperTier = tiers.find((tier) => traffic <= tier.maxTraffic);

  return mapBetweenRanges(
    traffic,
    lowerTier.maxTraffic,
    upperTier.maxTraffic,
    lowerTier.maxTraffic * lowerTier.price,
    upperTier.maxTraffic * upperTier.price
  ).toFixed(2);
}
